export class SaleLine {
   constructor(product_id, product_name, product_type, pieces, time_minutes, price, subtotal){
      this.product_id = product_id
      this.product_name = product_name
      this.product_type = product_type
      this.pieces = pieces
      this.time_minutes = time_minutes
      this.price = price
      this.subtotal = subtotal
   }  
}